import { styled } from '@mui/material'
import { useRef } from 'react'
import { BucketMedia } from '../../../../graphql/generated'
import formatImageProxyUrl from '../../utils/formatImageProxyUrl'

interface VideoPlayerProps {
  media: BucketMedia
}

const StyledVideo = styled('video')(() => ({
  outline: 'none',
  margin: 'auto',
  width: '100%',
  height: '100%'
}))

const StyledContainer = styled('div')(() => ({
  width: '80%',
  height: '100%'
}))

export default function VideoPlayer({ media }: Readonly<VideoPlayerProps>) {
  const videoRef = useRef<HTMLVideoElement>(null)

  const loadingSrc = formatImageProxyUrl(media) as string
  const src = media?.imageUrl

  return (
    <StyledContainer>
      <StyledVideo ref={videoRef} controls poster={src ?? loadingSrc}>
        <track kind="captions" />
        {media.signedUrl && <source src={media.signedUrl} />}
        <p>Your browser does not support HTML5 video.</p>
      </StyledVideo>
    </StyledContainer>
  )
}
